import { Badge, Button, ButtonProps } from '@mui/material'
import { useNavigate } from 'react-router'
import { useAppSelector } from 'store/configureStore'

export const RFQInboxButton = (props: ButtonProps) => {
  const navigate = useNavigate()
  const partyId = useAppSelector((state) => state.user?.organizationContext?.id)
  const count = useAppSelector((state) => state.quotationExchange.rfqInboxCount)

  if (!partyId) {
    return null
  }

  return (
    <Badge
      badgeContent={count}
      color="primary"
      showZero={false}
      max={99}
      sx={{
        '& .MuiBadge-badge': {
          top: 4,
          right: 4,
          transform: 'none',
        },
      }}
    >
      <Button
        {...props}
        onClick={() => {
          navigate('/app/request-for-quotations/inbox')
        }}
      >
        RFQ Inbox
      </Button>
    </Badge>
  )
}

export const RFQOutboxButton = (props: ButtonProps) => {
  const navigate = useNavigate()
  const partyId = useAppSelector((state) => state.user?.organizationContext?.id)

  if (!partyId) {
    return null
  }

  return (
    <Button
      {...props}
      onClick={() => navigate('/app/request-for-quotations/outbox')}
    >
      RFQ Outbox
    </Button>
  )
}
